import type { Thing, WithContext } from 'schema-dts'

/**
 * Custom implementation of useJsonld for adding JSON-LD structured data to pages
 * Replaces the nuxt-jsonld module with a lightweight custom solution
 *
 * @param schema - Schema.org structured data object
 * @returns void
 */
export const useJsonld = <T extends Thing>(schema: WithContext<T>): void => {
  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(schema),
      },
    ],
  })
}
